/* tslint:disable:variable-name */
import {User} from '@docma-mm-core/user/user';
import {Structure} from '@docma-mm-core/structure/structure';
import {Craft} from '@docma-mm-core/craft/craft';
import {Company} from '@docma-mm-core/company/company';
import {Order} from '@docma-mm-core/order/order';
import {Contact} from '@docma-mm-core/contact/contact';
import {Classification} from '@docma-mm-core/classification/classification';
import {UserDefined} from '@docma-mm-core/user-defined/user-defined';
import {ActivityData} from '@docma-mm-core/activity/activity';
import {AttachmentData} from '@docma-mm-core/attachment/attachment';
import {FilterCriteria} from '@docma-mm-core/filter/filter-criteria';
import {FaultSortingSourceEnum} from './fault-sorting-source.enum';
import {FaultSortingItem} from './fault-sorting-item';
import {Attribute} from '@docma-mm-core/attribute/attribute';
import { BpPin } from '../../bp-common/models/bp-pin';

export enum FaultPoolFilterMode {
  Include = 0,
  Exclude = 1
}

export class FaultSearch {
  constructor(init?: Partial<FaultSearch>) {
    if (init) {
      Object.assign(this, init);
    }
  }
  Fields?: string[];
  Structure?: string;
  PoolId?: string;
  LayoutId?: string;
  Ids?: number[];
  SUids?: string[];
  UniqueIds?: string[];
  Company?: string;
  Status?: string;
  AdditionalInformations?: number;
}

export class FaultPoolFilter {
  PoolId?: number;
  Mode?: FaultPoolFilterMode;

  constructor(init?: Partial<FaultPoolFilter>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}

export class FaultDataSearch
{
  constructor(init?: Partial<FaultDataSearch>) {
    if (init) {
      Object.assign(this, init);
    }
  }
  Structure?: string;
  Ids?: number[];
  UniqueIds?: string[];
  LayoutId?: number;
  OnlyDefectId?: boolean;
  IncludedFields?: string[];
  ModifiedAfter?: Date;
  ModifiedBefore?: Date;
  Filter?: FaultDataSearchFilter;
  SortingSource?: FaultSortingSourceEnum;
  Sorting?: FaultSortingItem[];
  AdditionalData?: string[];
  IsLayoutFilterDisabled?: boolean;
  FieldFormats: {[fieldFormat: string]: any} = {};
  FieldCriteriaFormats: {[fieldFormat: string]: any} = {};
  IncludeGroupFieldsInFilterCriteria = false;
  FaultPoolFilters?: FaultPoolFilter[];
}

export class FaultDataSearchFilter {
  Mode?: any;
  FilterItems: FaultDataSearchFilterItem[];
}
export class FaultDataSearchFilterItem {
  Criterias: FilterCriteria[];
}


export class FaultData {
  Id?: number;
  UniqueId?: string;
  SUid?: string;
  Number1?: number;
  Number2?: string;
  Number2Prefix?: string;
  Number2Suffix?: string;
  Desc1_1?: string;
  Desc1_2?: string;
  Desc1_3?: string;
  Desc2_1?: string;
  Desc2_2?: string;
  Desc2_3?: string;
  Structure?: Structure;
  Craft?: Craft;
  Company?: Company;
  Order?: Order;
  ContactCO?: Contact;
  ContactCT?: Contact;
  ContactSC?: Contact;
  Class1?: Classification;
  Class2?: Classification;
  Class3?: Classification;
  Class4?: Classification;
  UserDefined1?: UserDefined;
  UserDefined2?: UserDefined;
  CostsCompany?: Company;
  CostsOrder?: Order;
  Costs1?: number;
  Costs2?: number;
  Costs3?: number;
  Costs4?: number;
  Costs5?: number;
  Date1?: string;
  Date2?: string;
  Date3?: string;
  Text1?: string;
  Text2?: string;
  Text3?: string;
  Opt1?: boolean;
  Opt2?: boolean;
  Opt3?: boolean;
  Opt4?: boolean;
  Opt5?: boolean;
  Opt6?: boolean;
  Opt7?: boolean;
  Opt8?: boolean;
  Opt9?: boolean;
  IsVisibleForCO?: boolean;
  IsVisibleForCT?: boolean;
  Attribute?: Attribute;
  CreatedOn?: Date;
  ModifiedOn?: Date;
  CreatedOnMobile?: Date;
  ModifiedOnMobile?: Date;
  Creator?: User;
  Modifier?: User;
  Activities?: ActivityData[];
  Files?: AttachmentData[];
  IS_CANCELLED?: number;
  IsLocked?: boolean;
  PlanId?: number;
  PlanPositionX?: number;
  PlanPositionY?: number;
  PlanRelativeAnchorToParentPositionX?: number;
  PlanRelativeAnchorToParentPositionY?: number;
  Pin?: BpPin;
  PoolIds?: number[];
  SearchIds?: number[];

  constructor(fault?: Partial<FaultData> ) {
    if (fault) {
      Object.assign(this, fault);
      if (this.CreatedOn) {
        this.CreatedOn = new Date(this.CreatedOn);
      }
      if (this.ModifiedOn) {
        this.ModifiedOn = new Date(this.ModifiedOn);
      }
      if (this.CreatedOnMobile) {
        this.CreatedOnMobile = new Date(this.CreatedOnMobile);
      }
      if (this.ModifiedOnMobile) {
        this.ModifiedOnMobile = new Date(this.ModifiedOnMobile);
      }
      if (fault.Files) {
        this.Files = fault.Files.map(a => new AttachmentData(a));
      }
      if (fault.Activities) {
        this.Activities = fault.Activities.map(a => new ActivityData(a));
      }
      if (fault.Costs1) {
        this.Costs1 = Number(fault.Costs1.toFixed(2));
      }
      if (fault.Costs2) {
        this.Costs2 = Number(fault.Costs2.toFixed(2));
      }
      if (fault.Costs3) {
        this.Costs3 = Number(fault.Costs3.toFixed(2));
      }
      if (fault.Costs4) {
        this.Costs4 = Number(fault.Costs4.toFixed(2));
      }
      if (fault.Costs5) {
        this.Costs5 = Number(fault.Costs5.toFixed(2));
      }

    }
  }

}
export class FaultsData {
  Data: FaultData[];
  Count: number;
}
